import { useCallback, useEffect, useRef, useState } from 'react';

// The reel visually settles (re-enabling its own CTA) before this reveal
// delay finishes and the offer card actually swaps in, so `isRevealing`
// stays true through that gap too, letting callers keep the CTA disabled.
export const useOfferReveal = (delayMs: number) => {
  const [isRevealing, setIsRevealing] = useState(false);
  const timeoutRef = useRef<number>();

  useEffect(() => () => window.clearTimeout(timeoutRef.current), []);

  const reveal = useCallback(
    (onRevealed: () => void) => {
      setIsRevealing(true);
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => {
        onRevealed();
        setIsRevealing(false);
      }, delayMs);
    },
    [delayMs]
  );

  return { isRevealing, reveal };
};
